/**
 * @generated SignedSource<<7a61892fece1e472ff33d3e9ad74a1bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type SurveyStatus = "AVAILABLE" | "FAIL" | "PENDING" | "SUCCESS";
import { FragmentRefs } from "relay-runtime";
export type SurveyListFragment_surveysRef$data = {
  readonly surveys: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly status: SurveyStatus;
        readonly tags: ReadonlyArray<string>;
        readonly " $fragmentSpreads": FragmentRefs<"SurveyCard_survey">;
      };
    }>;
    readonly pageInfo: {
      readonly totalCount: number | null;
    };
  } | null;
  readonly " $fragmentType": "SurveyListFragment_surveysRef";
};
export type SurveyListFragment_surveysRef$key = {
  readonly " $data"?: SurveyListFragment_surveysRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"SurveyListFragment_surveysRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./SurveyListRefetchQuery.graphql')
    }
  },
  "name": "SurveyListFragment_surveysRef",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "concreteType": "SurveyConnection",
      "kind": "LinkedField",
      "name": "surveys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SurveyEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Survey",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tags",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SurveyCard_survey"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8ee5a54a8a4d7adfa9ff0f1d07f41ea0";

export default node;
